module.exports = __webpack_public_path__ + "static/media/cb_4.800391f4.svg";